let listenerCheck = false;
// barathLayout.sfpInit('cover');

const slidingHeader = new SlidingSticky(headerID,256);

const mobileMenuSwitch = new Switch({
    state: 0,
    targetId: 'slide-in-wrapper',
    buttonId: 'button-menu-mobile',
    activeClass: 'menu-mobile-open',
    onFunction: () => {


        slidingHeader.disable();
        

        let header = document.getElementById('site-header');

        header.style.pointerEvents = "none";

        if (header.classList.contains("bg-opacity-0")) {

            barathLayout.disableHeaderTransparent(true,1);

            const clickFunction =()=> {
                
                header.style.pointerEvents = "all";
                menu.mobileMenuOn();
                header.removeEventListener("transitionend",clickFunction,true);
                menu.fixedViewOn();
            };

            header.addEventListener("transitionend", clickFunction, true);

        } else {

            barathLayout.disableHeaderTransparent(true,1);
            menu.mobileMenuOn();
            header.style.pointerEvents = "all";
            menu.fixedViewOn();

        }
    },
    offFunction: () => {
        slidingHeader.enable();
        // menu.mobileMenuOff();
        // barathLayout.disableHeaderTransparent(false);
        let panel = document.getElementById('menu-mobile');
        let header = document.getElementById('site-header');
        header.style.pointerEvents = "none";
        mobileSubmenuSwitches.forEach((mySwitch)=>{
            mySwitch.off();
        });

        const clickFunction =()=> {
            barathLayout.disableHeaderTransparent(false,1);
            header.style.pointerEvents = "all";
            panel.removeEventListener("transitionend",clickFunction,true);
            
        };

        panel.addEventListener("transitionend", clickFunction, true);
        menu.mobileMenuOff();
        menu.fixedViewOff();

    }
});

const mobileSubmenuSwitches = [];
const submenuSwitches = [];




scroll.track();


const scriptsRunOnce = () => {

    //call functions here which will run once;

    consoleGreatings();

    detectFeatures();

    slideInPanel.operate('menu-mobile',"off");
    slideInPanel.operate('sub-work',"off");

    mobileMenuSwitch.init();
    slidingHeader.start();

    coverSizeControl(homePageCoverSettings);

    // slider footert és számlálót a helyére rakja
    if (document.getElementById('cover-footer') ) {
        barathLayout.sfpInit('cover');
    }

    createGlideSliders();
    // slider footert és számlálót a helyére rakja

    scriptsOnScroll();

    animateOnScroll();

    // activateSmoothScroll();

    handleCookieBar();

    // mostanra beálltak az oldalon az elemek, meg lehet jeleníteni
    document.getElementById('all-in').classList.add('visible');

    // setTimeout(barathLayout.refreshHeaderTransparency, 500);
    barathLayout.setHeaderStyleAtScroll();
    barathLayout.setCoverHideOnScroll();

    barathLayout.contentMarginBottom();
    barathLayout.contentMarginTop();
    barathLayout.refreshHeaderStyle();

    // Create Submenu Switches >>>
    const submenus = document.querySelectorAll(".n_desktopmenu .n_has-submenu");
    submenus.forEach(function(elem) {

        let i = submenuSwitches.push( new Switch( {

            buttonId: elem.getAttribute("id"),
            targetId: elem.getAttribute("href"),

            onFunction: () => {
                
                slidingHeader.disable();

                let header = document.getElementById('site-header');
                header.style.pointerEvents = "none";
                if (header.classList.contains("bg-opacity-0")) {

                    barathLayout.disableHeaderTransparent(true,1);
                    const clickFunction =()=> {
                        slideInPanel.operate(elem.getAttribute("href").substring(1),"on");
                        header.style.pointerEvents = "all";
                        header.removeEventListener("transitionend",clickFunction,true);
                    };
                    header.addEventListener("transitionend", clickFunction, true);
                } else {
                    barathLayout.disableHeaderTransparent(true,1);
                    slideInPanel.operate(elem.getAttribute("href").substring(1),"on");
                    header.style.pointerEvents = "all";
                    console.log('no transition');
                }

            },

            offFunction: () => {

                

                let panel = document.getElementById(elem.getAttribute("href").substring(1));
                let header = document.getElementById('site-header');

                header.style.pointerEvents = "none";

                const clickFunction =()=> {
                    console.log('Transition Ended');
                    barathLayout.disableHeaderTransparent(false,1);
                    header.style.pointerEvents = "all";
                    slidingHeader.enable();
                    panel.removeEventListener("transitionend",clickFunction,true);
                };

                panel.addEventListener("transitionend", clickFunction, true);

                slideInPanel.operate(elem.getAttribute("href").substring(1),"off");

            }

        }));
        submenuSwitches[i-1].init();

    });
    // <<< Create Submenu Switches

    // Create Mobile Submenu Switches >>>
    const mobileSubmenus = document.querySelectorAll("#menu-mobile .n_has-submenu");

    mobileSubmenus.forEach(function(elem) {
        document.getElementById( elem.getAttribute("href").substring(1)).style.maxHeight = "0px";
        let i = mobileSubmenuSwitches.push( new Switch( {
            buttonId: elem.getAttribute("id"),
            targetId: elem.getAttribute("href"),
            onFunction: () => {
                menu.triggerMobileSubmenu(elem.getAttribute("href").substring(1),1);
            },
            offFunction: () => {
                menu.triggerMobileSubmenu(elem.getAttribute("href").substring(1),0);
            }
        } ) );
        mobileSubmenuSwitches[i-1].init();

    });
    // <<< Create Mobile Submenu Switches


      console.log(mobileSubmenuSwitches);
    //don't touch below ;-)
    setTimeout(scriptsOnWinResize, 333);

    // window.scrollTo(0,0);

}


const scriptsOnWinResize = () => {

    //call functions here which will run once + on window resize event
    vhCalc();
    coverSizeControl(homePageCoverSettings);

    slideInPanel.setWrapperMarginTop(document.getElementById(headerID).offsetHeight);
    menu.setMobileMenuHeight( slideInPanel.getWrapperHeight() );

    barathLayout.contentMarginBottom();
    barathLayout.contentMarginTop();
    barathLayout.alignSubmenuPosition('sub-work');
    // barathLayout.alignPandaAside();


    if (document.getElementById('site-header') != null && document.querySelector('#cover footer') != null) {
        barathLayout.setSliderNavPosition(
            'cover',
            document.getElementById('site-header').offsetHeight,
            document.querySelector('#cover footer').offsetHeight
        )
    }

    //don't touch below ;-)
    scriptsOnScroll();

}



const scriptsOnScroll = () => {

    //call functions here which will run once + on window resize event + on window scroll event
    siteHeaderZIndex();//DEMO #7
    // coverFooterVerticalPosition();//DEMO #4
    if (isHomePage()) {
        kindOfSticky('cover');//DEMO #6
    }
    // headerPositionSetter();
    // changeHeaderStyle();


}



const scriptsOnScrollStrict = () => {

    //call functions here which will stricktly on window scroll event
    scroll.directionChangeEvent();


}



document.addEventListener("DOMContentLoaded", function(event) {

    devSays('JavaScript',1,'DOM content loaded.' );

    //every script runs once
    scriptsRunOnce();

    //window scroll event
    window.addEventListener('scroll', function(){
        scriptsOnScroll();
        scriptsOnScrollStrict();
        // debounce(() => scriptsOnScroll());
        // debounce(() => scriptsOnScrollStrict());
    });

    //window resize event
    let scriptsOnWinResizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(scriptsOnWinResizeTimer);
        scriptsOnWinResizeTimer = setTimeout(scriptsOnWinResize, 333);
    });

    document.querySelector(".n_tothetop").addEventListener("click", function() {
        scroll.scrollToY(0,500);
      });



    //ez belescrolloz egy kicsit az oldalba
    if (typeof scrollInContentFromBottom !== 'undefined' && scrollInContentFromBottom) {

        /*
        console.log("evaling scrollin");

        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

        console.log(viewportWidth);

        if (viewportWidth > 640) { // larger than sm breakpoint

            // az elso parameter a scroll mennyisege px-ben, a masodik az idotartam ms-ban;
            setTimeout(function () {
                    scrollIn(200, 400)
                        .then(() => {
                            slidingHeader.enable();
                            slidingHeader.reset();
                            return ('slideing header reeanabled');
                        })
                        .catch((err) => {
                            console.log(err)
                        });
                },
                1000
            );
        }

         */

    }

});

// bezarjuk a menuket ha mellekattintunk:
// az if statementben azok az elemek vannak amikre kattintva nincsen melle-kattintas
window.addEventListener('click', function(e){
    if ( !document.getElementById('menu-mobile').contains(e.target)
        && !document.getElementById('sub-work').contains(e.target)
        && !document.getElementById('site-header').contains(e.target) ){
        submenuSwitches.forEach((mySwitch)=>{
            mySwitch.off();
        });
        mobileMenuSwitch.off();
    }
})

function handleCookieBar() {
    if (document.cookie.split(';').some((item) => item.trim().startsWith('db_cookie_bar='))) {
        // has cookie
    } else {
        // does not have cookie
        document.getElementById('cookie-bar').classList.remove(['invisible']);
    }
}

function acceptCookieBar() {
    document.cookie = "db_cookie_bar=accepted; max-age=7592000";
    document.getElementById('cookie-bar').classList.add(['invisible']);
}

function activateSmoothScroll() {
    const lenis = new Lenis({
        // duration: 1.2,
        // easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
        // direction: "vertical",
        // gestureDirection: "vertical",
        // smooth: true,
        // smoothTouch: false,
        // touchMultiplier: 2,
        lerp: 0.1,
        wheelMultiplier: 0.7,
        infinite: false,
        gestureOrientation: "vertical",
        normalizeWheel: false,
        smoothTouch: false
    });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
}